import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { MdClose } from "react-icons/md";
import { HiMenuAlt2 } from "react-icons/hi";
import { motion } from "framer-motion";
import { logoLight } from "../../../assets/images";
import Image from "../../designLayouts/Image";
import { navBarList } from "../../../constants";
import Flex from "../../designLayouts/Flex";
import { List, ListItem, ListItemSuffix, Typography, ListItemPrefix, } from '@material-tailwind/react';
import {
  // PresentationChartBarIcon,
  ShoppingBagIcon,
  UserCircleIcon,
  // Cog6ToothIcon,
  InboxIcon,
  PowerIcon,
} from "@heroicons/react/24/solid";
import { BsBookmarkHeart } from "react-icons/bs"

const HeaderProf = () => {
  const [showMenu, setShowMenu] = useState(true);
  const [sidenav, setSidenav] = useState(false);
  const location = useLocation();
  useEffect(() => {
    let ResponsiveMenu = () => {
      if (window.innerWidth < 667) {
        setShowMenu(false);
      } else {
        setShowMenu(true);
      }
    };
    ResponsiveMenu();
    window.addEventListener("resize", ResponsiveMenu);
  }, []);

  return (
    <div className="w-full h-20 bg-white sticky top-0 z-50 border-b-[1px] border-b-gray-200">
      <nav className="h-full px-4 max-w-container mx-auto relative">
        <Flex className="flex items-center justify-between h-full">
          <Link to="/">
            <div>
              <Image className="w-20 object-cover" imgSrc={logoLight} />
            </div>
          </Link>
          <div>
            {showMenu && (
              <motion.ul
                initial={{ y: 30, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.5 }}
                className="flex items-center w-auto z-50 p-0 gap-2"
              >
                <>
                  {navBarList.map(({ _id, title, link }) => (
                    <NavLink
                      key={_id}
                      className="flex font-normal hover:font-bold w-20 h-6 justify-center items-center px-12 text-base text-[#767676] hover:underline underline-offset-[4px] decoration-[1px] hover:text-[#262626] md:border-r-[2px] border-r-gray-300 hoverEffect last:border-r-0"
                      to={link}
                      state={{ data: location.pathname.split("/")[1] }}
                    >
                      <li>{title}</li>
                    </NavLink>
                  ))}
                </>
              </motion.ul>
            )}
            <HiMenuAlt2
              onClick={() => setSidenav(!sidenav)}
              className="inline-block md:hidden cursor-pointer w-8 h-6 absolute top-6 right-4"
            />
            {sidenav && (
              <div className="fixed top-0 left-0 w-full h-screen bg-black text-gray-200 bg-opacity-80 z-50">
                <motion.div
                  initial={{ x: -300, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ duration: 0.5 }}
                  className="w-[80%] h-full relative"
                >
                  <div className="w-full h-full bg-primeColor p-6">
                    <img
                      className="w-28 mb-6"
                      src={logoLight}
                      alt="logoLight"
                    />
                    <ul className="text-gray-200 flex flex-col gap-2">
                      <div className="mb-2 p-4">
                        <Typography variant="h5" color="white">
                          Akun Saya
                        </Typography>
                      </div>
                      <List>
                        <a href="/profile" className="text-initial">
                          <ListItem >
                            <ListItemPrefix>
                              <UserCircleIcon color="white" className="h-5 w-5" />
                            </ListItemPrefix>
                            <Typography variant="lead" color="white" >
                            Profile
                            </Typography>
                          </ListItem>
                        </a>
                        <a href="/alamat" className="text-initial">
                          <ListItem >
                            <ListItemPrefix>
                              <ShoppingBagIcon color="white" className="h-5 w-5" />
                            </ListItemPrefix>
                            <Typography variant="lead" color="white" >
                            Alamat
                            </Typography>
                          </ListItem>
                        </a>

                        <a href="/wishlistitem" className="text-initial">
                          <ListItem>
                            <ListItemPrefix>
                              <BsBookmarkHeart color="white" className="h-5 w-5" />
                            </ListItemPrefix>
                            <Typography variant="lead" color="white" >
                            Wishlist
                            </Typography>
                            <ListItemSuffix>
                              {/* <Chip value="3" size="sm" variant="ghost" color="blue-gray" className="rounded-full" /> */}
                            </ListItemSuffix>
                          </ListItem>
                        </a>
                        <a href="/pesanan" className="text-initial">
                          {/* <Link to="/pesanan"> */}
                          <ListItem>
                            <ListItemPrefix>
                              <InboxIcon color="white" className="h-5 w-5" />
                            </ListItemPrefix>
                            <Typography variant="lead" color="white" >
                            Pesanan
                            </Typography>
                            <ListItemSuffix>
                              {/* <Chip value="3" size="sm" variant="ghost" color="white" className="rounded-full" /> */}
                            </ListItemSuffix>
                          </ListItem>
                          {/* </Link> */}
                        </a>
                        <Link to="/">
                          <ListItem>
                            <ListItemPrefix>
                              <PowerIcon color="white" className="h-5 w-5" />
                            </ListItemPrefix>
                            <Typography variant="lead" color="white" >
                            Log Out
                            </Typography>
                          </ListItem>
                        </Link>
                      </List>
                    </ul>
                  </div>
                  <span
                    onClick={() => setSidenav(false)}
                    className="w-8 h-8 border-[1px] border-gray-300 absolute top-2 -right-10 text-gray-300 text-2xl flex justify-center items-center cursor-pointer hover:border-red-500 hover:text-red-500 duration-300"
                  >
                    <MdClose />
                  </span>
                </motion.div>
              </div>
            )}
          </div>
        </Flex>
      </nav>
    </div>
  );
};

export default HeaderProf;
